export const mutations = {
  addBanniere(state, banniere) {
    state.banniere = banniere
  },
  setBanniere(state, banniere) {
    state.banniere = banniere
  },
  addBannieres(state, banniere) {
    state.bannieres = [...banniere]
  },
  addBannieresPage(state, banniere) {
    state.bannieres = banniere
  }
}
